import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import LogoArrow from './LogoArrow';

import logo from './intoto-logo.svg';

export interface LogoProps {
  isMobile?: boolean;
  title?: string;
  subtitle?: string;
  extraContent?: ReactElement;
}

const version = process.env.REACT_APP_VERSION_HASH || 'develop';

window.intoto = () => {
  const p = document.getElementById('logo-pizza');
  if (p) p.style.display = 'block';
  return '🍕 It\'s a pizza party! 🍕';
};

function Logo({
  title,
  subtitle,
  extraContent,
  isMobile = false,
}: LogoProps) {
  return (
    <>
      <Box
        sx={{
          position: 'relative',
          flexGrow: 1,
          alignItems: 'center',
          display: 'flex',
          mr: 2,
        }}
        className="IntotoLogo"
      >
        <Box
          id="logo-pizza"
          sx={{
            display: 'none',
            position: 'absolute',
            top: '1px',
            left: isMobile ? '3px' : '4px',
            fontSize: isMobile ? '17px' : '21px',
            transform: 'rotate(41deg)',
            pointerEvents: 'none',
          }}
        >
          🍕
        </Box>
        <Box
          component={Link}
          to="/"
          sx={{
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <LogoArrow
            size={isMobile ? 24 : 32}
            title={`Intoto v: ${version}`}
          />
          {!title && !isMobile && (
            <Box
              component="img"
              src={logo}
              alt="Intoto Studio"
              width={100}
              height={23.16}
              sx={{
                ml: 2,
                mr: 1,
              }}
            />
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {!isMobile && title && (
            <Typography
              variant="h5"
              component="h1"
              sx={{
                ml: 2,
                mr: 1,
                fontWeight: 'bold',
              }}
            >
              {title}
            </Typography>
          )}
          {!isMobile && extraContent}
        </Box>
      </Box>
      {!isMobile && subtitle && (
        <Box sx={{ ml: 6 }}>
          <Typography variant="body1" sx={{ color: 'text.disabled' }}>
            {subtitle}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default Logo;
